// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"06706c1e","239":"5491b2ce","453":"a830a7a8","977":"df0fc418"}[chunkId] + ".chunk.js";
};